export default [
    {
    path: "/users",
    name: "Users",
    component: () => import("@/pages/users/UserListPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/users/new",
    name: "NewUser",
    component: () => import("@/pages/users/NewUserPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/users/profile",
    name: "UserProfile",
    component: () => import("@/pages/users/UserProfilePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/users/roles",
    name: "Roles",
    component: () => import("@/pages/users/RoleListPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/users/roles/new",
    name: "NewRole",
    component: () => import("@/pages/users/NewRolePage.vue"),
    meta: { requiresAuth: true },
  },
]
